import { ReportsViewService } from './ReportsViewService';
import { ReportsData } from '../reportsViewSlice/types';
import { data } from './mockData';

export const ReportsViewServiceImpl: ReportsViewService = {
  getReportsData: async (): Promise<ReportsData> => {
    // return axios
    //     .get<GoogleUserInfo>(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`, {
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`,
    //             Accept: 'application/json'
    //         }
    //     })
    //     .then((user) => {
    //         return user.data;
    //     })
    return Promise.resolve(data);
  },
};
